<template>
  <el-dialog
    :title="$t('contractTypeSpecManage.delete.title')"
    :visible.sync="visible"
    width="30%"
    custom-class="contract-type-spec-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('contractTypeSpecManage.delete.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteContractTypeSpec } from '@/api/contract/contractTypeSpecManageApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'DeleteContractTypeSpec',
  data() {
    return {
      visible: false,
      formData: {
        specCd: '',
        communityId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.formData = {
        specCd: data.specCd,
        communityId: getCommunityId()
      }
      this.visible = true
    },
    handleClose() {
      this.formData = {
        specCd: '',
        communityId: ''
      }
    },
    async handleConfirm() {
      try {
        await deleteContractTypeSpec(this.formData)
        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || this.$t('contractTypeSpecManage.delete.error'))
      }
    }
  }
}
</script>

<style scoped>
.contract-type-spec-dialog >>> .el-dialog { border-radius: 12px; overflow: hidden; }
.contract-type-spec-dialog >>> .el-dialog__header {
  height: 66px; box-sizing: border-box; padding: 22px 24px;
  background: #EBF2FA; border-bottom: 1px solid #DCE6F5;
}
.contract-type-spec-dialog >>> .el-dialog__title {
  font-size: 16px; color: #1D2129; font-weight: 600;
}
.contract-type-spec-dialog >>> .el-dialog__body {
  padding: 24px 24px 8px;
}
.contract-type-spec-dialog >>> .el-dialog__footer {
  padding: 8px 24px 28px;
  display: flex; justify-content: flex-end; gap: 12px;
}
</style>